import type { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import type { ThreePlanogram } from "../store/types";
import { Bay } from "./Bay/Bay";

interface Props {
  bays: PlanogramBay[];
  showDividers?: boolean;
  three: ThreePlanogram;
}

export const Bays = ({ bays, showDividers, three }: Props) => {
  return bays.map((bay, index) => (
    <Bay key={bay.uniqueId} bay={bay} bayIndex={index} showDividers={showDividers} three={three} />
  ));
};
